<template>
  <!-- <DxPopup @hidden="onHidden" :visible="makePop2" :show-close-button="true" :show-title="true" :title="'Popup Make Request Insp (OutsideCom.)'" height="autofocus" width="autofocus" container=".v-application">  :resize-enabled="true"-->
  <DxPopup @hidden="onHidden" :visible="makePop2" :show-close-button="true" :show-title="true" :title="'Popup Make Request Insp (OutsideCom.)'" :height= window.heights  :width= window.widths container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="'Make Request Inspection'"
                         :useBtnList="useBtnList"
                         @btnRetrieve="btnRetrieve" @btnApplyRequestInsp="btnApplyRequestInsp" @btnClose="btnClose"
        >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters>
                <v-col cols="12">
                  <i-card-top
                      class="d-md-flex"
                      outlined
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-0 pl-1">
                        <v-col cols="12">
                          <v-row dense>
                            <i-label :label="'Supplier name : '"/>
                            <v-col cols="3">
                              <v-select
                                  v-model="supName"
                                  :items="supNameList"
                                  item-value="custCd"
                                  item-text="supName"
                                  return-object
                                  single-line
                                  outlined
                                  dense
                                  @change="supNameChange"
                              ></v-select>
                            </v-col>
                            <i-label :label="'Duration Div : '" class="pl-2"/>
                            <v-col cols="2">
                              <v-select
                                  v-model="durDiv"
                                  :items="durDivList"
                                  item-value="code"
                                  item-text="codeName"
                                  return-object
                                  single-line
                                  outlined
                                  dense
                              ></v-select>
                            </v-col>
                            <v-col cols="2">
                              <DxDateBox
                                  :value="stDate"
                                  height="30px"
                                  display-format="yyyy-MM-dd"
                                  :acceptCustomValue="false"
                                  @value-changed="e => {stDate = e.value}"
                              />
                            </v-col>
                            <span class="pt-2">~</span>
                            <v-col cols="2">
                              <DxDateBox
                                  :value="edDate"
                                  height="30px"
                                  display-format="yyyy-MM-dd"
                                  :acceptCustomValue="false"
                                  @value-changed="e => {edDate = e.value}"
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row dense style="background-color: #DFE3D5; border-top: 2px solid #214885; border-right: 1px solid #bcc0c9; border-left: 1px solid #bcc0c9;">
                <v-col
                    v-for="n in 4"
                    :key="n"
                    style="border-right: 1px solid #bcc0c9"
                >
                  <v-row no-gutters v-if="n === 1">
                    <v-col cols="5" align="right" class="pt-1 pr-2">
                      <span class="pa-2 pr-0 subText"> shipNo: </span>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                          v-model="shipNo"
                          dense
                          outlined
                          hide-details="auto"
                          height="32"
                          maxlength="8"
                          readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="n === 2">
                    <v-col cols="5" align="right" class="pt-1 pr-2">
                      <span class="pa-2 pr-0 subText"> Search POR: </span>
                    </v-col>
                    <v-col cols="7">
                      <v-select
                          v-model="porNo"
                          :items="porNoList"
                          item-value="porNo"
                          item-text="porNo"
                          return-object
                          single-line
                          outlined
                          dense
                          @change="btnRetrieve()"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="n === 3">
                    <v-col cols="5" align="right" class="pt-1 pr-2">
                      <span class="pa-2 pr-0 subText"> Search Block: </span>
                    </v-col>
                    <v-col cols="7">
                      <v-select
                          v-model="block"
                          :items="blockList"
                          item-value="block"
                          item-text="block"
                          return-object
                          single-line
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="n === 4">
                    <v-col cols="5" align="right" class="pt-1 pr-2">
                      <span class="pa-2 pr-0 subText"> Insp.Place: </span>
                    </v-col>
                    <v-col cols="7">
                      <v-select
                          v-model="inspLoc"
                          :items="inspLocList"
                          item-value="code"
                          item-text="codeName"
                          return-object
                          single-line
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2" align="center" class="pt-2">
                  <span class="pa-2 pr-0 subText">LQC memeber </span>
                </v-col>
              </v-row>
              <v-row dense class="mt-0"  style="background-color: #DFE3D5; border-top: 1px solid #bcc0c9; border-bottom: 2px solid #214885; border-right: 1px solid #bcc0c9; border-left: 1px solid #bcc0c9;">
                <v-col
                    v-for="n in 4"
                    :key="n"
                    style="border-right: 1px solid #bcc0c9"
                >
                  <v-row no-gutters v-if="n === 1">
                    <v-col cols="5" align="right" class="pt-1 pr-2">
                      <span class="pa-2 pr-0 subText"> QM Part: </span>
                    </v-col>
                    <v-col cols="7">
                      <v-select
                          v-model="qmPart"
                          :items="qmPartList"
                          item-value="code"
                          item-text="codeName"
                          return-object
                          single-line
                          outlined
                          dense
                          disabled
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="n === 2">
                    <v-col cols="5" align="right" class="pt-1 pr-2">
                      <span class="pa-2 pr-0 subText"> Insp. date: </span>
                    </v-col>
                    <v-col cols="7">
                      <DxDateBox
                          :value="insDate"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {insDate = e.value}"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="n === 3">
                    <v-col cols="5" align="right" class="pt-1 pr-2">
                      <span class="pa-2 pr-0 subText"> Insp. time: </span>
                    </v-col>
                    <v-col cols="7">
                      <v-select
                          v-model="insTime"
                          :items="insTimeList"
                          item-value="codeName"
                          item-text="timeNm"
                          return-object
                          single-line
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="n === 4">
                    <v-col cols="5" align="right" class="pt-1 pr-2">
                      <span class="pa-2 pr-0 subText"> Insp.Y/N: </span>
                    </v-col>
                    <v-col cols="7">
                      <v-select
                          v-model="inspYn"
                          :items="inspYnList"
                          item-value="code"
                          item-text="codeName"
                          return-object
                          single-line
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2" align="center" class="pa-1">
                  <v-select
                      v-model="empLqc"
                      :items="empLqcList"
                      item-value="empNo"
                      item-text="enm"
                      return-object
                      single-line
                      outlined
                      dense
                  ></v-select>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <!-- :height="600" -->
                  <DxDataGrid id="v80o1020MakePop2"
                              :ref="v80o1020MakePop2Ref"
                              :height= window.heightDx
                              :data-source="gridMainList"
                              :remote-operations="false"
                              :hover-state-enabled="true"
                              :allow-column-resizing="true"
                              :allow-column-reordering="true"
                              :row-alternation-enabled="true"
                              :show-borders="true"
                              :width="grid.width"
                              :show-row-lines="true"
                              key-expr="id"
                              :focused-row-enabled="false"
                              :column-hiding-enabled="false"
                              :word-wrap-enabled="true"
                              :sorting="{mode: 'none'}"
                  >
                    <DxColumn data-field="shipNo" caption="Ship No" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="inspYn" width="3%" data-type="boolean" alignment="center" header-cell-template="inspYn" edit-cell-template="inspYnSel" :allow-editing="false" />
                    <template #inspYn>
                      <div>Insp<br>Y/N</div>
                    </template>
                    <template #inspYnSel="{ data: cellInfo }">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="true" />
                    </template>

                    <!-- <DxColumn data-field="whYn" width="3%" data-type="boolean" alignment="center" header-cell-template="whYn" edit-cell-template="whYnSel" :allow-editing="false" />
                    <template #whYn>
                      <div>WH<br>Y/N</div>
                    </template>
                    <template #whYnSel="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                      :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </template> -->

                    <DxColumn data-field="inspStat" width="9%" data-type="string" alignment="center" header-cell-template="inspstatus" edit-cell-template="inspStat" :allow-editing="false" />
                    <template #inspstatus>
                      <div>Insp.<br>Status</div>
                    </template>
                    <template #inspStat="{ data }">
                      <div>
                        <div v-if="data.data.inspYn == 'Y'">Accepted</div>
                        <div v-if="data.data.inspYn != 'Y' ? true : false">{{data.text}}</div>
                      </div>
                    </template>

                    <DxColumn data-field="itemDesc" caption="Inspection Items" width="20%" data-type="string" alignment="left" :allow-editing="false" />

                    <DxColumn data-field="addInfo" width="20%" data-type="string" alignment="center" header-cell-template="addInfo" :allow-editing="true" />
                    <template #addInfo="{ data }">
                      <div><div>Additional Info. <br><span class="allBtn" @click="allBtn(data)">(All)</span></div></div>
                    </template>
                    
                    <!-- header-cell-template="kindCd" -->
                    <DxColumn data-field="kindCd" width="20%" data-type="string" header-cell-template="kindCd" alignment="center" :allow-editing="true">
                      <DxLookup :data-source="inspKindList" display-expr="kindNm" value-expr="kindCd" />
                    </DxColumn>
                    <template #kindCd="{ data }">
                      <div><div>Insption kind<br><span class="allBtn" @click="allBtn(data)">(All)</span></div></div>
                    </template>

                    <DxColumn data-field="porNoSeq" caption="POR No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="block" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="delyQty" caption="Qty" width="4%" data-type="string" alignment="center" :allow-editing="true" />

                    <DxColumn caption="QM" width="3%" data-type="boolean" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="wqm" width="3%" data-type="boolean" alignment="center" :allow-editing="false" header-cell-template="QM" edit-cell-template="wqm" />
                    </DxColumn>
                    <DxColumn caption="OW" width="3%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wow" >
                      <DxColumn data-field="wow" width="3%" data-type="boolean" alignment="center" :allow-editing="false" header-cell-template="OW" edit-cell-template="wow" />
                    </DxColumn>
                    <DxColumn caption="CL" width="3%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wcl" >
                      <DxColumn data-field="wcl" width="3%" data-type="boolean" alignment="center" :allow-editing="false" header-cell-template="CL" edit-cell-template="wcl" />
                    </DxColumn>
                    <DxColumn caption="MK" width="3%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wmk" >
                      <DxColumn data-field="wmk" width="3%" data-type="boolean" alignment="center" :allow-editing="false" header-cell-template="MK" edit-cell-template="wmk" />
                    </DxColumn>
                    <template #QM = "{ data: cellInfo }" >
                      <div><DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onValueChanged(value, cellInfo)"/></div>
                    </template>
                    <template #OW = "{ data: cellInfo }" >
                      <div><DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onValueChanged(value, cellInfo)"/></div>
                    </template>
                    <template #CL = "{ data: cellInfo }" >
                      <div><DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onValueChanged(value, cellInfo)"/></div>
                    </template>
                    <template #MK = "{ data: cellInfo }" >
                      <div><DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onValueChanged(value, cellInfo)"/></div>
                    </template>

                    <template #wqm="{ data: cellInfo }">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                  :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </template>
                    <template #wow="{ data: cellInfo }">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                  :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </template>
                    <template #wcl="{ data: cellInfo }">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                  :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </template>
                    <template #wmk="{ data: cellInfo }">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                  :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </template>



                    <DxPaging :enabled="true" :page-size= "5" />
                    <DxPager :visible="true"  :showInfo="false" />
                  </DxDataGrid>
                  <span style="font-weight: bold;">Count Total: {{ totalRow }} Row(s)</span>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxDataGrid, DxEditing, DxColumn , DxPager ,DxLookup } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import { getNetday , getLastDate , v80o1020AddList , v80o1010Save } from '@/api/view/hip/8/v80o1020Popup.js'
import { v80WeldEmp , addList , getPorNoList , getBlockList } from '@/api/view/hip/8/v80a1080Pop.js'
import { getDateFormat , getCurrentDate , lpad} from '@/utils/common.js'
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getLqcMember } from '@/api/view/hip/8/v80a1040.js'
import { format } from 'echarts';

export default {
  name: 'v80o1020MakePop2',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    ICardVertical,
    iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPager,
    DxDateBox,
    DxLookup
  },
  props: {
    makePop2: {
      type: Boolean,
      default() { return false }
    },
    popupData: {
      type: Array,
      default() { return }
    },
    supNameListPop: {
      type: Array,
      default() { return }
    },
    insTimeListPop: {
      type: Array,
      default() { return }
    },
    qmPartListPop: {
      type: Array,
      default() { return }
    },
    inspLocListPop: {
      type: Array,
      default() { return }
    },
    empLqcListPop: {
      type: Array,
      default() { return }
    },
    inspKindListPop: {
      type: Array,
      default() { return }
    },
  },
  data() {
    return {
      useBtnList: ['btnRetrieve' , 'btnApplyRequestInsp' , 'btnClose'],
      v80o1020MakePop2Ref: 'v80o1020MakePop2Ref',
      gridMainList: [],
      totalRow: 0,

      durDiv: '',
      durDivList: [],
      custCd: null,
      supName: null,
      supNameList: this.supNameListPop,
      shipNo: '',
      stDate: '',
      edDate: '',
      porNo: '',
      porNoList: [],
      block: '',
      blockList:[],

      qmPart: '',
      qmPartList: this.qmPartListPop,

      insDate: null,
      insTime: null,
      insTimeList: this.insTimeListPop,
      empLqc: this.empLqcListPop[0],
      empLqcList: this.empLqcListPop,

      inspYn: '',
      inspYnList:[],

      inspLoc: '',
      inspLocList: this.inspLocListPop,

      inspKindList: this.inspKindListPop,

      window: {
            widths: 0,
            heights: 0,
            heightDx: 0
      }

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.v80o1020MakePop2Ref)
    },
  },
  watch: {
    'makePop2': {
      handler(value, oldValue) {
        if(value) {
          
          this.durDiv =  ''
          this.durDivList = []
          this.custCd = null
          this.supName = null
          this.supNameList = this.supNameListPop
          this.shipNo = ''
          this.stDate = ''
          this.edDate =  ''
          this.porNo =  ''
          this.porNoList =  []
          this.block =  ''
          this.blockList = []

          this.qmPart =  ''
          this.qmPartList =  this.qmPartListPop

          this.insDate =  null
          this.insTime =  null
          this.insTimeList =  this.insTimeListPop
          this.empLqc =  this.empLqcListPop[0]
          this.empLqcList =  this.empLqcListPop
          this.inspYn =  ''
          this.inspYnList = []
          this.inspLoc =  ''
          this.inspLocList =  this.inspLocListPop
          this.inspKindList = this.inspKindListPop

          // this.window = {
          //   widths: 0,
          //   heights: 0,
          //   heightDx: 0
          // }

          this.supName = this.popupData.supName
          this.qmPart = this.popupData.qmPart
          this.shipNo = this.popupData.shipNo
          this.insDate = this.popupData.stDate
          this.getList()

          window.addEventListener('resize', this.handleResize);
          window.removeEventListener('resize', this.handleResize);
          this.handleResize();
        }
      },
      immediate: true
    }

  },
  mounted(){
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.gridMainInstance.option('defaultPaging', false)
  },
  // created() {
  //       window.addEventListener('resize', this.handleResize);
  //       this.handleResize();
  //   },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    }, 
  methods: {

    handleResize() {
      this.window.widths = window.innerWidth - 100;
      this.window.heights = window.innerHeight - 100;
      this.window.heightDx = window.innerHeight - 360;
    },

    getStrFormat(date) {
      // this.insDate = date
      return getDateFormat(date)
    },
    async getList(){
      let supNameGbn = this.supName
      supNameGbn = supNameGbn.split(' : ')
 
      //  this.inspKindList.forEach(e => {
      //    if (e.kindNm != null) {
      //        e.kindNm = e.kindCd + ': ' + e.kindNm
      //   }else{
      //        e.kindNm = ''
      //   }
      //  }); 

      let param = {
        code: '',
        codegr: '',
        prtCode: 'DUR_DIV',
        userFlag: 'Y',
        format: '-5',
        makerCd: supNameGbn[0],
        shipNo: this.shipNo
      }
      await getCmChildCode(param).then(res => {
        this.durDivList = res.list
        this.durDiv = res.list[0]
      })

      await getNetday(param).then(res => {
        this.stDate = res.list[0].netDay
      })
      let param2 = {
        format: '0',
        code: '',
        codegr: '',
        prtCode: 'CMD_INSP_YN',
        userFlag: 'Y',
      }

      await getLastDate(param2).then(res => {
        this.edDate = res.list[0].aftDate
      })

      await getPorNoList(param).then(res => {
        if(res.list.length){
          this.porNoList = res.list
        }
      })

      await getBlockList(param).then(res => {
        if(res.list.length){
          this.blockList = res.list
        }
      })

      await getCmChildCode(param2).then(res => {
        this.inspYnList = res.list
        this.inspYn = res.list[0]
      })

      this.doSearchMain()
    },
    onHidden(e) {
      let param  = {

          stDate: dayjs(this.popupData.stDate).format('YYYY-MM-DD'),
          inspDiv: this.popupData.inspDiv.code,
          supName: this.popupData.supName,
          shipNo: this.popupData.shipNo,
          qmPart: this.popupData.qmPart.code
      }
      // console.log('onHidden Test: ', param)
      // this.popupData.supName = this.supName
      // this.popupData.stDate = this.insDate
      // this.popupData.attendInsp = {kindCd: '' , kindNM: ''}
      // this.popupData.resultInsp = {insResCd: '%' , codeName: 'insResNm'}

      // this.$emit('isSaved',  this.popupData)
      this.$emit('makeSave',   param)
      this.$emit('update:makePop2', false)
    },
    isSave(){
      let param  = {

          stDate: dayjs(this.popupData.stDate).format('YYYY-MM-DD'),
          inspDiv: this.popupData.inspDiv.code,
          supName: this.popupData.supName,
          shipNo: this.popupData.shipNo,
          qmPart: this.popupData.qmPart.code
      }
      // console.log('isSave', param)
      // this.popupData.supName = this.supName
      // this.popupData.stDate = this.insDate
      // this.popupData.attendInsp = {kindCd: '' , kindNM: ''}
      // this.popupData.resultInsp = {insResCd: '%' , codeName: 'insResNm'}

      // this.$emit('isSaved',  this.popupData)
      this.$emit('makeSave',  param)
    },
    async doSearchMain(){

     
      this.gridMainList = []
      this.totalRow = 0
      let supNameGbn = this.supName
      supNameGbn = supNameGbn.split(' : ')

      let params = {
        custCd: supNameGbn[0],
        shipNo: this.shipNo,
        block: !this.block.block ? '' : this.block.block ,
        stDte: dayjs(this.stDate).format('YYYY-MM-DD'),
        edDte: dayjs(this.edDate).format('YYYY-MM-DD'),
        porNo: !this.porNo.porNo ? '' : this.porNo.porNo,
        cmdInspYn: !this.inspYn.code ? '' : this.inspYn.code,
        durDiv: !this.durDiv.code ? '' : this.durDiv.code

      }
      
      try {
        this.openLoading('searching')
        
        await v80o1020AddList(params).then(res => {
          if(res.list.length){
            let cnt = 1
            res.list.forEach(e => {
              e.id = cnt++
              e.porNoSeq = e.porNo + '-' + e.porSeq
            });
            this.gridMainList = res.list
            this.totalRow = res.list.length
          }
        })
      } finally {
        this.endLoading()
      }
    },
    supNameChange(){
      let supNameGbn = this.supName
      if(supNameGbn === 'Select Supplier'){
        this.custCd = ''
      } else {
        supNameGbn = supNameGbn.split(' : ')
        this.custCd = supNameGbn[0]
      }

      if(this.$store.state.user.userGrd !== 'A'){
        this.custCd = this.$store.state.user.makerCd
      }

      let params = {
        makerCd: this.custCd
      }
      getLqcMember(params).then(res => {
        this.empLqcList.push({empNo: '' , enm: 'Select LQC..'})
        res.list.forEach(e => {
          this.empLqcList.push(e)
        });
      })
      this.getList()
    },
    btnRetrieve(e){
      if(!this.inspYn){
        this.inspYn = 'N'
      }
      if(!this.supName){
        this.vToastify(this.$t('There is no Supplier to retrieve.'), 'warn')
        return
      }
      // //shipNo
      if(!this.shipNo){
        this.vToastify(this.$t('Select the Ship No to retrieve.'), 'warn')
        return
      }
      this.doSearchMain()
    },
    async btnApplyRequestInsp(){
      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
      let minDate = new Date
      minDate.setDate(minDate.getDate() + 1);
      minDate = dayjs(minDate).format('YYYY-MM-DD')

      if(!this.empLqc.empNo){
        this.vToastify(this.$t('Please select LQC membert!'), 'warn')
        return
      }
      if(!this.inspLoc){
        this.vToastify(this.$t('Please select Inspection place!'), 'warn')
        return
      }

      if(!selectedMainRows.length){
        this.vToastify(this.$t('Data is not selected!.'), 'warn')
        return
      }

      let supNameGbn = this.supName
      supNameGbn = supNameGbn.split(' : ')


      for(var row of selectedMainRows){
        if(row.shipNo != this.shipNo){
          this.vToastify(this.$t('Ship No is different.'), 'warn')
          return
        }
        if(!row.kindCd){
          this.vToastify(this.$t('Kind of inspection not empty. Please, input data before make inspection request!'), 'warn')
          return
        }
        if(!this.insDate){
          this.vToastify(this.$t('Select Inspection Date.'), 'warn')
          return
        }
        if(!this.insTime){
          this.vToastify(this.$t('Select Inspection Time.'), 'warn')
          return
        }
        if(dayjs(this.insDate).format('YYYY-MM-DD') < minDate){
          this.vToastify(this.$t('You cannot inspection request the inspection of this day. You select Inspection Date over today please!'), 'warn')
          return
        }

        let filter = []
        filter = this.supName.split(' : ')
        let actSubstring = row.mact.substring(0,7)
        row.custCd = filter[0]
        row.porNo = !row.porNo ? '' : row.porNo
        row.porSeq = !row.porSeq ? '' : row.porSeq
        row.inspAct = this.inspLoc.code + this.qmPart.code + row.kindCd + row.block + actSubstring + row.porNo + lpad(row.porSeq, 3,'0')

        row.qmPart = this.qmPart.code
        row.insDate = dayjs(this.insDate).format('YYYY-MM-DD')
        row.insTime = this.insTime.codeName
        row.inspQty = row.delyQty
        row.inspLoc = this.inspLoc.code
        row.empNo = this.empLqc.empNo
      }

      try{
        this.openLoading('searching')
        v80o1010Save(selectedMainRows).then(res => {
          if(res.body == 'Y'){
            notify(this.$t('Request Inspection saving is completed.'), 'success', 3000)
          }else {
            this.vToastify(this.$t('An error has been occured while saving data : ' + "<br>" + res.body), 'warn')
          }
          this.doSearchMain()
          this.isSave()
        })
            .catch(error => {
              this.vToastify(error, 'warn')
              this.endLoading()
            })
            .finally(() => {
              this.gridMainInstance.clearSelection()
            })
      } finally{
        this.endLoading()
      }
    },
    btnClose(){
      this.onHidden()
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '0px'
      }
    },
    async onValueChanged(value, cellInfo){
      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
      if(value.value === true){
        for(let i = 0; i < this.gridMainList.length; i++){
          for(let j = 0; j < selectedMainRows.length; j++){
            if(selectedMainRows[j].id == this.gridMainList[i].id){
              this.gridMainList[i][cellInfo.column.dataField] = 'Y'
            }
          }
        }
      } else {
        for(let i = 0; i < this.gridMainList.length; i++){
          for(let j = 0; j < selectedMainRows.length; j++){
            if(selectedMainRows[j].id == this.gridMainList[i].id){
              this.gridMainList[i][cellInfo.column.dataField] = 'N'
            }
          }
        }
      }
    },
    onValueChanged2(value, cellInfo){
      cellInfo.component.cellValue([cellInfo.rowIndex], cellInfo.columnIndex, cellInfo.value === 'Y' ? 'N' : 'Y')
      cellInfo.component.updateDimensions()
    },
    async allBtn(e){
      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
      for(let i = 0; i < this.gridMainList.length; i++){
        for(let j = 0; j < selectedMainRows.length; j++){
          if(selectedMainRows[j].id == this.gridMainList[i].id){
            this.gridMainList[i][e.column.dataField] = this.gridMainInstance.cellValue('0', e.columnIndex)
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: rgb(135,155,119);
  margin-right: 2px;
  font-size: 10pt;
  color: white;
}
.btnClick{
  padding: 0;
  font-size: 12px;
}
.btnClick:hover{
  color: #4980BC;
}
.subText {
  font-size: 10pt;
  font-weight: bold;
  color: black;
}
.allBtn {
  cursor: pointer;
}
.allBtn:hover {
  color: #4980BC;
}
</style>